module.exports = __webpack_public_path__ + "img/clear.b112db31.png";